module.exports = __webpack_public_path__ + "media/images/link-d3c2ecd700c653fbc6ba3c7f2e8b5978.png";